import React from 'react';
import { Container, Row } from 'reactstrap';
import { FeatureBox } from './featureBox/FeatureBox';
import { Feature } from './types';
import { TypedMemo } from '../../../components/types';

const FeaturesComponent: React.FC<{ title: string; features: Feature[] }> = ({ title, features, children }) => {
  return (
    <div className="py-5" style={{ background: 'rgba(222, 55, 106, 0.1)' }}>
      <Container className="py-5">
        <p className="main-header text-secondary text-center mb-2 mb-lg-2">{title}</p>
        {children}
        <Row className="justify-content-center">
          {features.map((feature) => {
            return <FeatureBox key={feature.title.id} feature={feature} />;
          })}
        </Row>
      </Container>
    </div>
  );
};

export const Features = TypedMemo(FeaturesComponent);
